import {apiAction} from './api'
import {DESK_DESK} from './endpoint'
import {GET_USER_NOTIFICATION, UPDATE_USER_NOTIFICATION} from './types'

export function getUserNotifications(page) {
  return apiAction({
    url: `${DESK_DESK}/user-notifications?page=${page}`,
    method: 'GET',
    label: GET_USER_NOTIFICATION,
  })
}

export function markAsRead(id) {
  return apiAction({
    url: `${DESK_DESK}/user-notifications/${id}/read`,
    method: 'PUT',
    label: UPDATE_USER_NOTIFICATION,
    successMessage: 'Notification Updated',
    showToast: true,
  })
}
